import { useState, useEffect } from "react";

const DEBOUNCE_DELAY = 500;

export const useDebouncedSearchTerms = (searchTerms) => {
  const [debouncedSearchTerms, setDebouncedSearchTerms] = useState({});

  useEffect(() => {
    if (Object.keys(searchTerms).length === 0) {
      setDebouncedSearchTerms({});
      return;
    }

    const timers = {};
    Object.keys(searchTerms).forEach((itemId) => {
      timers[itemId] = setTimeout(() => {
        setDebouncedSearchTerms((prev) => ({
          ...prev,
          [itemId]: searchTerms[itemId],
        }));
      }, DEBOUNCE_DELAY);
    });

    return () => {
      Object.values(timers).forEach((timer) => clearTimeout(timer));
    };
  }, [searchTerms]);

  return debouncedSearchTerms;
};

